<template>
  <v-row class="pt-8 pl-5 pb-6 ma-0">
    <v-btn color="primary" elevation="0" @click="openDialog">Add Note</v-btn>

    <v-dialog v-model="dialog" max-width="600">
      <v-card>
        <v-card-title class="d-flex">
          <span class="headline flex-grow-1">Add Note</span>
          <v-btn color="secondary" outlined elevation="0" @click="closeDialog">Close</v-btn>
        </v-card-title>
        <v-card-text>
          <v-form lazy-validation @submit.prevent="() => {}">
            <v-text-field v-model="notesData.title" label="Title *"></v-text-field>

            <v-select
              v-model="notesData.selectedType"
              :items="typeOptions"
              clearable
              label="Select Issue Type"
            ></v-select>

            <v-combobox
              v-if="notesData.stop_id || enableFreeCreation"
              v-model="notesData.stop_id"
              clearable
              label="Stop ID"
              :items="stopItems"
              item-text="title"
            ></v-combobox>

            <v-combobox
              v-if="notesData.route_id || enableFreeCreation"
              v-model="notesData.route_id"
              clearable
              label="Route ID"
              :items="routeItems"
              item-text="title"
            ></v-combobox>

            <v-combobox
              v-if="notesData.vehicle_id || enableFreeCreation"
              v-model="notesData.vehicle_id"
              clearable
              label="Vehicle ID"
              :items="vehicleItems"
              item-text="title"
            ></v-combobox>

            <v-combobox
              v-if="notesData.device_id || enableFreeCreation"
              v-model="notesData.device_id"
              clearable
              label="Device ID"
              :items="deviceItems"
              item-text="title"
            ></v-combobox>

            <v-text-field
              v-if="notesData.case_id"
              v-model="notesData.case_id"
              disabled
              readonly
              label="Case ID"
            ></v-text-field>

            <v-textarea v-model="notesData.comments" label="Comments *"></v-textarea>

            <v-select
              v-model="notesData.selectedPriority"
              :items="priorityOptions"
              label="Select Priority *"
            ></v-select>

            <v-select v-model="notesData.selectedStatus" :items="statusOptions" label="Select Status *"></v-select>

            <v-text-field v-model="notesData.claimant" label="Created By *"></v-text-field>

            <v-select v-model="notesData.assigned" clearable :items="assignedOptions" label="Assigned To"></v-select>

            <v-text-field v-model="notesData.location" label="Location (optional)"></v-text-field>

            <v-btn class="mt-7" color="primary" :disabled="note_cannotSave" @click="addNote()"> Add </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
import { mapState } from "vuex"
import store from "@/store"

export default {
  name: "NotesForm",
  data() {
    return {
      dialog: false,
    }
  },
  props: {
    notesData: {
      type: Object,
      required: true,
    },
    enableFreeCreation: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    ...mapState({
      devices: state => state.gtfs.devices,
      stops: state => state.gtfs.stops,
      routes: state => state.gtfs.routes,
      notes: state => state.gtfs.notes,
    }),

    priorityOptions() {
      return ["Low", "Medium", "High", "Urgent"]
    },

    statusOptions() {
      return ["Open", "Pending", "On Hold", "Closed"]
    },

    typeOptions() {
      return ["Not Running", "Confirmation Rate", "Observation"]
    },

    assignedOptions() {
      return ["GWRC", "Operator", "Somar", "Radiola", "Quickstart", "Other"]
    },

    stopItems() {
      return this.stops.map(stop => ({
        title: stop && stop.stop_code && stop.stop_name ? `${stop.stop_code} - ${stop.stop_name}` : "Unknown",
        value: stop.stop_id,
      }))
    },

    routeItems() {
      return this.routes.map(route => ({
        title:
          route && route.route_short_name && route.route_long_name
            ? `${route.route_short_name} - ${route.route_long_name}`
            : "Unknown",
        value: route.route_id,
      }))
    },

    vehicleItems() {
      return this.devices.map(device => ({
        title: device && device.config.vehicle_id ? device.config.vehicle_id : null,
        value: device.config.vehicle_id,
      }))
    },

    deviceItems() {
      return this.devices.map(device => ({
        title: device ? device.device_id : "Unknown",
        value: device.device_id,
      }))
    },

    note_cannotSave() {
      return (
        !this.notesData.title ||
        !this.notesData.comments ||
        !this.notesData.selectedPriority ||
        !this.notesData.selectedStatus ||
        !this.notesData.claimant
      )
    },
  },
  methods: {
    openDialog() {
      this.dialog = true
    },

    closeDialog() {
      this.dialog = false
    },
    async addNote() {
      try {
        // if fields filled out
        if (
          this.notesData.title.trim() !== "" &&
          this.notesData.comments.trim() !== "" &&
          this.notesData.selectedPriority &&
          this.notesData.selectedStatus !== null &&
          this.notesData.claimant.trim() !== ""
        ) {
          await this.$store.dispatch("addNote", { formData: this.notesData })

          store.commit("SET_SNACKBAR", {
            text: `The note ${this.notesData.title} has been added`,
            color: "success",
          })

          // Reset the form fields after successful submission
          this.notesData = {
            title: "",
            issue_type: "",
            stop_id: "",
            route_id: "",
            vehicle_id: "",
            device_id: "",
            case_id: "",
            comments: "",
            selectedPriority: null,
            selectedStatus: null,
            claimant: "",
            assigned: "",
            location: "",
          }

          this.dialog = false
        }
      } catch (error) {
        console.error("error:", error)
        store.commit("SET_SNACKBAR", {
          text: `The note ${this.notesData.title} could not be added`,
          color: "error",
        })
      }
    },
  },
}
</script>

<style lang="scss">
</style>
